export default "/_next/static/assets/download-apple_eded375b3abd0fa65a65aa5ba9514130.png";